<template>
    <div>
        <div v-if="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit('form')">
                <el-form-item label="Title" prop="title">
                    <el-input v-model="form.title" placeholder="Enter a product feature title"></el-input>
                </el-form-item>
                <el-form-item label="Description" prop="desc">
                    <el-input v-model="form.desc" type="textarea" placeholder="Enter a product feature description" rows="5"></el-input>
                </el-form-item>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
                <el-button @click="onCancel('form')">Cancel</el-button>
            </el-form>
        </div>
        <div v-else>
            <el-button type="primary" size="mini" @click="dialogVisible = true">
                Add Feature
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                desc: null,
                title: null,
            },
            rules: {
                'desc': [
                    { required: true, message: 'Enter a product feature description.', trigger: 'blur' },
                    { min: 140, max: 280, message: 'Length should be 140 to 280.', trigger: 'blur' },
                ],
                'title': [
                    { required: true, message: 'Enter a product feature title.', trigger: 'blur' },
                ],
            },
        }
    },

    props: {
        productId: {
            type: String,
        },
    },

    methods: {
        onSubmit(form) {
            this.loading = true

            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.post(`/product-features`, {
                        product_id: this.productId,
                        desc: this.form.desc,
                        title: this.form.title,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.dialogVisible = false
                this.$refs[form].resetFields()
                this.$emit('create')
                this.$message.success(data.message)
            })
        },

        onCancel(form) {
            this.dialogVisible = false
            this.$refs[form].resetFields()
        },
    },
}
</script>
